var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Alert = function (_a) {
    var children = _a.children, _b = _a.type, type = _b === void 0 ? 'info' : _b, onClose = _a.onClose, _c = _a.className, className = _c === void 0 ? '' : _c;
    var baseClasses = 'p-4 rounded-xl border backdrop-blur-sm transition-all duration-300';
    var typeClasses = {
        info: 'bg-info-muted/80 dark:bg-info-muted/20 border-info/20 dark:border-info text-info dark:text-info',
        success: 'bg-success-muted/80 dark:bg-success-muted/20 border-success/20 dark:border-success text-success dark:text-success',
        warning: 'bg-warning-muted/80 dark:bg-warning-muted/20 border-warning/20 dark:border-warning text-warning dark:text-warning',
        error: 'bg-error-muted/80 dark:bg-error-muted/20 border-error/20 dark:border-error text-error dark:text-error',
    };
    var icons = {
        info: 'ℹ️',
        success: '✅',
        warning: '⚠️',
        error: '❌',
    };
    return (_jsx("div", __assign({ className: "".concat(baseClasses, " ").concat(typeClasses[type], " ").concat(className) }, { children: _jsxs("div", __assign({ className: "flex items-start space-x-3" }, { children: [_jsx("span", __assign({ className: "text-lg" }, { children: icons[type] })), _jsx("div", __assign({ className: "flex-1" }, { children: children })), onClose && (_jsx("button", __assign({ onClick: onClose, className: "text-current opacity-50 hover:opacity-100 transition-opacity duration-200" }, { children: "\u2715" })))] })) })));
};
export { Alert };
